import { faPlay } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useRef, useState } from 'react'
import { useKeyPressEvent } from 'react-use'

import VideoEmbed from '@/components/misc/VideoEmbed'
import { useIsHovered } from '@/hooks/useIsHovered'
import { RECOMMENDED_PARTNER_VIDEO_HEIGHT } from '@/pages/professionalNetworkRelationships/constants'
import { useRecommendedPartner } from '@/pages/professionalNetworkRelationships/hooks/useRecommendedPartner'
import { useRecommendedPartnerSteps } from '@/pages/professionalNetworkRelationships/hooks/useRecommendedPartnerSteps'

const WatchVideo: React.FC = () => {
  const recommendedPartner = useRecommendedPartner()
  const [isPlayingVideo, setIsPlayingVideo] = useState<boolean>()
  const { goToNextStep } = useRecommendedPartnerSteps()
  const videoThumbnailRef = useRef<HTMLDivElement | null>(null)
  const isHoveringOverThumbnail = useIsHovered(videoThumbnailRef)

  // Play video on spacebar press
  useKeyPressEvent(' ', () => {
    if (!isPlayingVideo) {
      setIsPlayingVideo(true)
    }
  })

  if (!recommendedPartner.videoUrl) {
    goToNextStep()
    return null
  }

  if (isPlayingVideo || !recommendedPartner.videoThumbnailFileUrl) {
    return (
      <>
        <VideoEmbed
          videoUrl={recommendedPartner.videoUrl}
          height={RECOMMENDED_PARTNER_VIDEO_HEIGHT}
          autoplay={isPlayingVideo}
          style={{ borderRadius: '10px' }}
        />
      </>
    )
  }

  const thumbnailImageUrl = recommendedPartner.videoThumbnailFileUrl

  return (
    <div
      ref={videoThumbnailRef}
      className="flex cursor-pointer flex-col items-center justify-center"
      style={{
        backgroundImage: `url(${thumbnailImageUrl})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        borderRadius: '10px',
        height: RECOMMENDED_PARTNER_VIDEO_HEIGHT,
        opacity: isHoveringOverThumbnail ? '0.95' : 1,
      }}
    >
      <div
        className="relative flex h-full w-full flex-col items-center
          justify-center gap-6 px-6 text-white"
        onClick={() => setIsPlayingVideo(true)}
      >
        <FontAwesomeIcon icon={faPlay} style={{ fontSize: '70px' }} />

        <div
          className="text-center font-bold text-white"
          style={{ fontSize: '26px' }}
        >
          {recommendedPartner.company.presentationName}
        </div>
      </div>
    </div>
  )
}

export default WatchVideo
